import { map } from 'lodash';
import React from 'react';
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { WebUrl } from "../../util/Constant";

const Breadcrumb = props => {
    const { data } = props;
    const _history = useHistory();
    const { t, i18n } = useTranslation();

    const handleNavigation = (item) => {
        // If navigating to VIP Event
        if (item.value === 'VIP_EVENT') {
            // Set the required token first
            localStorage.setItem("6FAZhVi1QvBGsKaUl7WPhVTwRPf1HUhF", "wdAvBAPKCPB1TvXPsfPSda8PUUdEGaHg");
            // Then navigate
            _history.push(item.link);
            return;
        }

        // For other routes, navigate normally
        _history.push(item.link);
    };

    return (
        <ul className='custom-breadcrumb mb-5'>
            {data &&
                data.length &&
                map(data, (item, index) => {
                    return (
                        <React.Fragment key={index}>
                            {item.active ? (
                                <li className='active'>
                                    {t(item.value)}
                                </li>
                            ) : (
                                <li
                                    className={item.active ? 'active' : ''}
                                    onClick={() => handleNavigation(item)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {t(item.value)}
                                </li>
                            )}
                        </React.Fragment>
                    );
                })
            }
        </ul>
    );
};

export default Breadcrumb;